import { config } from './config';
import { createAnalytics } from '../../../shared/browser-analytics';
export { analyticsLocation, isSensitiveUrl as isAuthCallback } from '../../../shared/browser-analytics';

const analytics = createAnalytics({
  win: window,
  doc: document,
  surface: 'dashboard',
  enabled: config.analyticsEnabled && !config.isDemo && !config.isSandbox,
});
export const initAnalytics = analytics.init;
export const trackPage = (_path?: string) => analytics.page();
export const track = analytics.track;
export const trackOnce = analytics.once;
export const passwordLinkReady = analytics.passwordLinkReady;
export function identify(user: { id: string }, org?: { id: string; name: string; planId: string | null }) {
  analytics.identify(user.id, org?.planId);
}

export const clearAnalyticsIdentity = analytics.clearIdentity;
